/* Generated USDT deposit helpers unit. */
// Display feedback only; the API remains the final financial authority.
export const WALLET_UNKNOWN_OUTCOME = '처리 결과를 확인하지 못했습니다. 중복 신청하지 말고 입출금 내역을 먼저 확인해주세요.';
const text = value => typeof value === 'string' ? value.trim() : '';
const knownMessages = { 'Not authenticated': '로그인 상태를 확인한 후 다시 이용해주세요.', 'Authentication expired': '로그인이 만료되었습니다. 다시 로그인해주세요.', 'Insufficient balance': '출금 신청 금액이 보유금액보다 많습니다. 금액을 확인해주세요.' };
const generic = /^(?:Request failed(?: with status code \d+)?|Unknown error occurred|Network Error|Failed to fetch|stale_wallet_request|timeout of \d+ms exceeded)$/i;
export const walletResultMessage = (result, fallback = '요청 처리 중 문제가 발생했습니다.') => {
  for (const value of [result?.message, result?.error, result?.error?.message, result?.response?.data?.message, result?.response?.data?.error]) {
    const message = text(value);
    if (Object.prototype.hasOwnProperty.call(knownMessages, message)) return knownMessages[message];
    if (message && !generic.test(message)) return message;
  }
  return text(fallback) || '요청 처리 중 문제가 발생했습니다.';
};
export const walletAmountFeedback = ({ amount, balance, withdrawal, password }) => {
  const value = typeof amount === 'number' ? amount : typeof amount === 'string' && /^\d+(?:,\d{3})*$/.test(amount.trim()) ? Number(amount.replace(/,/g, '')) : NaN;
  if (!Number.isSafeInteger(value) || value <= 0) return '신청 금액을 1원 이상의 숫자로 입력해주세요.';
  if (withdrawal && Number.isFinite(Number(balance)) && value > Number(balance)) return '출금 신청 금액이 보유금액보다 많습니다. 금액을 확인해주세요.';
  if (withdrawal && !text(password)) return '출금 비밀번호를 입력해주세요.';
  return '';
};
